import { render, staticRenderFns } from "./ProTable.vue?vue&type=template&id=6ac3ed2a&scoped=true"
import script from "./ProTable.vue?vue&type=script&lang=js"
export * from "./ProTable.vue?vue&type=script&lang=js"
import style0 from "./ProTable.vue?vue&type=style&index=0&id=6ac3ed2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3ed2a",
  null
  
)

export default component.exports